import styled from 'styled-components';

export const Quality = ({ text, title }) => {
  return (
    <QualityStyled>
      <h3 style={{ color: 'var(--primary-color)' }}>{title}</h3>
      <p>{text}</p>
    </QualityStyled>
  );
};

const QualityStyled = styled.div`
  padding: 2rem 1rem;
  border-left: 6px solid var(--border-color);
  background-color: var(--background-dark-grey);
  position: relative;
  width: 100%;
  p {
    padding: 1rem 0;
  }
  transition: all 0.2s ease-in-out;
  &:hover {
    border-left: 6px solid var(--primary-color);
    transform: translateY(3px);
  }
`;
